import { FETCH_ALL_CREATERS, FETCH_ALL_CREATERS_FAILURE, FETCH_ALL_CREATERS_SUCCESS, FETCH_STUDENT_SUBCRIPTIONS, FETCH_STUDENT_SUBCRIPTIONS_FAILURE, FETCH_STUDENT_SUBCRIPTIONS_SUCCESS, FETCH_TEACHER_SUBCRIBERS_SUCCESS, RESET_INITIAL_STATE, SUBSCRIBE_TO_TEACHER_FAILURE, SUBSCRIBE_TO_TEACHER_SUCCESS, UNSUBSCRIBE_TO_TEACHER_FAILURE, UNSUBSCRIBE_TO_TEACHER_SUCCESS, UPDATE_CREATOR_SUBSCRIPTION, UPDATE_CREATOR_SUBSCRIPTION_FOR_EXAM } from "../actions/subscribers";


const initialState = {
  techerData: "",
  subcribeSuccess: false,
  unsubcribeSuccess: false,
  isSubscribed: false,
  studentSubcriptions: [],
  allCreterwithSubStatus: [],
  isallCreterwithSubStatusloading: false,
  studentSubcriptionsloading: false,
  subcribeFail: false,
  unsubcribeFail: false,
};

const subscriberReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TEACHER_SUBCRIBERS_SUCCESS:
      return {
        ...state,
        techerData: action.payload.teacherdata,
        isSubscribed: action.payload.isSubscribed
      };
    case SUBSCRIBE_TO_TEACHER_SUCCESS:
      return {
        ...state,
        subcribeSuccess: !state.subcribeSuccess
      };

    case UNSUBSCRIBE_TO_TEACHER_SUCCESS:
      return {
        ...state,
        unsubcribeSuccess: !state.unsubcribeSuccess,
        isSubscribed: false
      };
    case FETCH_STUDENT_SUBCRIPTIONS:
      return {
        ...state,
        studentSubcriptionsloading: true
      };
    case FETCH_STUDENT_SUBCRIPTIONS_SUCCESS:
      return {
        ...state,
        studentSubcriptions: action.payload,
        studentSubcriptionsloading: false
      };
    case FETCH_STUDENT_SUBCRIPTIONS_FAILURE:
      return {
        ...state,
        studentSubcriptionsloading: false
      };
    case FETCH_ALL_CREATERS:
      return {
        ...state,
        isallCreterwithSubStatusloading: true,
      };

    case FETCH_ALL_CREATERS_SUCCESS:

      return {
        ...state,
        allCreterwithSubStatus: action.payload,
        isallCreterwithSubStatusloading: false,

      };
    case FETCH_ALL_CREATERS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isallCreterwithSubStatusloading: false,
      };

    case SUBSCRIBE_TO_TEACHER_FAILURE:
      return {
        ...state,
        subcribeFail: true
      };

    case UNSUBSCRIBE_TO_TEACHER_FAILURE:
      return {
        ...state,
        unsubcribeFail: true
      };


    case UPDATE_CREATOR_SUBSCRIPTION:
      const { creatorId, userId, isSubscribed } = action.payload;
      return {
        ...state,
        allCreterwithSubStatus: state.allCreterwithSubStatus.map(creator =>
          creator._id === creatorId
            ? {
              ...creator,
              subscribers: isSubscribed
                ? [...(creator.subscribers || []), userId]
                : (creator.subscribers || []).filter(id => id !== userId),
              isSubscribed
            }
            : creator
        )
      };

    case UPDATE_CREATOR_SUBSCRIPTION_FOR_EXAM:
      const { studentId, isSubscribed: isSubscribedForExam } = action.payload;
      return {
        ...state,
        techerData: state.techerData ? {
          ...state.techerData,
          subscribers: isSubscribedForExam
            ? Array.from(new Set([...(state.techerData.subscribers || []), studentId])) // Add studentId and remove duplicates
            : (state.techerData.subscribers || []).filter(id => id !== studentId), // Remove only this studentId


        } : state.techerData,
        // Update the separate isSubscribed flag in root state
        isSubscribed: isSubscribedForExam
      };

    case RESET_INITIAL_STATE:
      return {
        ...state,
        subcribeFail: false,
        unsubcribeFail: false,
      }


    default:
      return state;
  }
};

export default subscriberReducer;
